module.exports = __webpack_public_path__ + "img/Kettenfahrzeug.fbddfcb1.svg";